import { aggregateFee, PRRenewal, toInstruction, toIpRight, toRenewal, useIpContext, useIpRights, useRenewals } from "src/renewal/patent_renewal/patent_renewals";
import { Member } from "../patents";
import { renewalNoticesStatus, renewalNoticeStatusToString } from "src/renewal/state/modern_states";
import { importStatusExtraction } from "src/renewal/patent_renewal/modern_states";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { usePatents } from "../PatentsProvider";
import { AnnuityFieldsContext } from "./AnnuityFields";


export function PrAnnuityDataProvider({children}) {
  const {t} = useTranslation()

  // console.log("Using PR Annuity Fields")

  const {memberByReference} = usePatents()
  const {ownerByCostCenterId, costCenterById} = useIpContext()
  const {ipRightById, ipRightByRef, isLoading} = useIpRights()
  const {renewals} = useRenewals({})

  const renewalsByIpId = _.groupBy(renewals, r => r.ip_id)

  // console.log({ipRightByRef})

  const lastRenewalByMemberId: Record<number, PRRenewal> = _(renewalsByIpId)
    .toPairs()
    .map(([ip_id, renewals]) => {
      const last = _.maxBy(renewals, r => r.payment_date)
      const ipr = ipRightById[ip_id]
      const member = memberByReference[ipr?.ip_owner_patent_ref]
      if (!member || !last) return undefined
      return [member.familyMemberId, last]
    })
    .filter(Boolean)
    .fromPairs()
    .value()

  const loadingString = 'loading...' // TODO

  const annuityFields = {
    'renewals-status': (member: Member) => {
      if (isLoading) return loadingString;
      const prIpRight = ipRightByRef[member.internalReference]
      const ipRight = prIpRight ? toIpRight(prIpRight, ownerByCostCenterId) : undefined
      const statusInfo = importStatusExtraction({member, ipRight, prIpRight})
      const renewals = renewalsByIpId[prIpRight?.id]?.map(r => toRenewal(r, prIpRight))
      const status = renewalNoticesStatus({renewalStatus: statusInfo.status, renewals})
      // console.log({prIpRight, ipRight})
      // console.log({member, status})
      return renewalNoticeStatusToString(status, t)
    },
    'last-instruction': (member: Member) => {
      if (isLoading) return loadingString;
      const ipRight = ipRightByRef[member.internalReference]
      const instr = toInstruction(ipRight)
      if (instr) {
        return t(instr.instruction)
      } else {
        return ''
      }
    },
    'fee-due': (member: Member) => {
      if (isLoading) return loadingString;
      const renewal = lastRenewalByMemberId[member.familyMemberId]
      return renewal?.payment_date ?? ''
    },
    'fees': (member: Member) => {
      const renewal = lastRenewalByMemberId[member.familyMemberId]
      if (renewal?.fees) {
        const {amount, currency} = aggregateFee(renewal.fees)
        return {[currency]: amount}
      } else {
        return {}
      }
    },
    'instruction-due': (member: Member) => {
      if (isLoading) return loadingString;
      const renewal = lastRenewalByMemberId[member.familyMemberId]
      return renewal?.expected_invoice_sent_date ?? ''
    },
    'cost-centers': (member: Member) => {
      if (isLoading) return loadingString;
      const ipr = ipRightByRef[member.internalReference]
      return costCenterById[ipr?.cost_center_id]?.name ?? ''
    }
  }
  //console.log({annuityContext})

  return <AnnuityFieldsContext.Provider value={{ annuityFields, isLoading }}>{children}</AnnuityFieldsContext.Provider>
}